var bannerSwiper = [];
var bannerSwiperIndex = 0;
export default ({
    name : 'Header'
    , data () {
        return {
            bannerCount : 0,
            headerLogoImg : '',
            headerTitleColor : '',
            headerScrollClass : '',
            headerBottomColor : '',
            profileIconColor : ''
        }
    }
    , created () {
        this.code = 'common_header';
        this.basic = this.getDetailDataByCode(this.code);
        if (this.isSetBasicData('banner_image')) {
            this.originBannerList = this.basic.data.banner_image.value
        }
        if (templateType === 'banner') {
            window.addEventListener('scroll', this.setBannerScrollHeader);
            this.setHeaderLogoImg();
        }
        if (templateType === 'basic') {
            window.addEventListener('scroll', this.setBasicScrollHeader);
        }
        this.shopConfig = this.getDetailDataByCode('shop_config');
        return {}
    }
    , mounted () {
		this.publisher();
        if (typeof _cart != 'undefined' && document.querySelector('.MSH-cart-cnt') != null) {
            _cart.init(cartTotalCnt)
        }
    }
    , computed : {
        /* check */
        isUseHeader () {
            if (this.basic.use == 'N') return false;
            return true;
        }
        , isUseProfileLogo () {
            return this.isSetBasicData('prf_logo')
        }
        , isShowProfileLogo () {
            if (this.basic.data.prf_logo.value.length > 0) return true
            return false
        }
        , isUseProfileSubLogo () {
            let res = false;
            if (this.isSetBasicData('prf_sub_logo_use') === true && this.isSetBasicData('prf_sub_logo') === true) {
                if (this.basic.data.prf_sub_logo_use.value == 'Y') {
                    res = true;
                }
            }
            return res; 
        }
        , isShowProfileSubLogo () {
            if (this.basic.data.prf_sub_logo.value.length > 0) return true
            return false
        }
        /* assign */
        , profileBgColorStyle () {
            let backStyle = {}
            if (this.isSetBasicData('prf_bg_color') === true) {
                let prfBgColor = this.basic.data.prf_bg_color.value
                backStyle['backgroundColor'] = `#${prfBgColor}`
            }
            return backStyle
        }
        , profileLogoStyle () {
            let prfBgImgValue = (this.basic.data.prf_logo.value.length > 0) ? this.basic.data.prf_logo.value : this.basic.data.prf_logo.default
            if (templateType === 'banner') {
                this.setHeaderLogoImg();
                prfBgImgValue = this.headerLogoImg;
            }
            return { backgroundImage : "url(" + prfBgImgValue + ")" }
        }
        , profileLogoImg () {
            let prfBgImgValue = (this.basic.data.prf_logo.value.length > 0) ? this.basic.data.prf_logo.value : this.basic.data.prf_logo.default
            if (templateType === 'banner') {
                this.setHeaderLogoImg();
                prfBgImgValue = this.headerLogoImg;
            }
            return prfBgImgValue
        }
        , shopName () {
            if (this.isSetBasicData('shop_name') === false) return this.shopNameDefault 
            if (this.basic.data.shop_name.value.length == 0) return this.basic.data.shop_name.default
            return this.basic.data.shop_name.value
        }
        , textColorStyle () {
            let style = {};
            if (this.isSetBasicData('prf_text_color')) {
                style = { color : '#' + this.basic.data.prf_text_color.value };
            }
            if (templateType === 'banner') {
                this.setHeaderTitleColor();
                style = { color : '#' + this.headerTitleColor };
            }
            return style; 
        }
        , headerScrollStyle () {
            this.setHeaderBottomColor();
            return { 'border-bottom' : '1px solid #' + this.headerBottomColor };
        }
        , profileIconColorClass () {
            let profileIconColorClass = '';
            if (this.isSetBasicData('prf_icon_color')) {
                profileIconColorClass = 'bg' + this.basic.data.prf_icon_color.value;
            }
            if (templateType === 'banner') {
                this.setProfileIconColor();
                profileIconColorClass = 'bg' + this.profileIconColor;
            }
            return profileIconColorClass;
        }
        , profileIconColorStyle () {
            let profileIconColorValue = '000';
            if (this.isSetBasicData('prf_icon_color')) {
                profileIconColorValue = this.basic.data.prf_icon_color.value
            }
            if (templateType === 'banner') {
                this.setProfileIconColor();
                profileIconColorValue = this.profileIconColor;
            }
            return { 'color' : '#' + profileIconColorValue };
        }
        , scrollClass () {
            this.setHeaderScrollClass();
            return this.headerScrollClass; 
        }
        , searchClass () {
            let _class = {
                'left-move' : false
            }
            if (this.isUse() === true || this.viewHome === true) { 
                _class["left-move"] = true;
            }
            return _class;
        }
        , targetSohoSearch () {
            return this.getAdminEditMode() ? '' : '_blank'
        }
        /* link */
        , linkHome () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlHome
        }
        , linkCart () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlCart
        }
        , linkMyOrder () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlMyOrder
        }
        , linkMyPage () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlMyPage
        }
        , linkLogin () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlLogin
        }
        , linkSohoSearchUrl () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlSohoSearch
        }
		, notInputText () {
            return this.getAdminEditMode() ? false : true
        }
        , notUseBannerStyle () {
            let style = {
                'backgroundColor' : '#ddd'
            }
            if (this.useDesignBanner() === false) return style
            return {} 
        }
        , notUseBannerVisualTopStyle () {
            let style = {
				'overflow' : 'hidden'
            }
            if (this.useDesignBanner() === false) return style
            return {}
        }
        , bannerList () {
            this.fileterCurrentBannerImageDefault()
            let bannerData = this.basic.data
            let maxCnt = bannerData.banner_max_cnt.value;
            let list = []
            let originList = []
            for (let key in bannerData.banner_image.value) {
                if (bannerData.banner_image.value[key].length < 1) { continue; }
                if (maxCnt <= list.length) { break; }
                let link = this.getBannerLink(bannerData.banner_link_type.value[key], bannerData.banner_link.value[key], bannerData.banner_link_id.value[key]);
                let item = {
                    'image' : bannerData.banner_image.value[key]
                    , 'link' : link.link
                    , 'target' : link.target
                }
                list.push(item);
                originList.push(bannerData.banner_image.value[key])
            }
            this.bannerCount = list.length

            // bannerList 변경될때만 실행하기위해 사용(데이터 갱신 및 ui 변경까지 완료 후 실행한다.)
            this.$nextTick(function () {
                this.bannerSwipe();
            });
            return list
        }
        , getCustomName() {
            return this.shopConfig.custom_name;
        }
        , getHeaderBannerLink() {
            return this.shopConfig.header_banner_link;
        }
    }
    , methods : {
        publisher () {
            $m(window).on('scroll', function() {
                var	hd = $m('#header');
                var category = $m('#tpl-basic .category');
				var scrollTop = $m(window).scrollTop();
				if (scrollTop > 100 ){
					category.hide();
					hd.addClass('on');
				} else if(scrollTop < 100) {
					category.show();
					hd.removeClass('on');
				}
				if (hd.hasClass('on')) {
					hd.on('mouseleave',function(){
						$m(this).removeClass('over');
						category.hide();
					});
					hd.on('mouseover',function(){
						$m(this).addClass('over');
						category.show();
					});
				} else {
					hd.on('mouseleave',function(){
						$m(this).addClass('over');
						category.show();
					});
					hd.on('mouseover',function(){
						$m(this).addClass('over');
						category.show();
					});
				}
			});
        }
        , fileterCurrentBannerImageDefault () {
            if (this.isEmptyBannerImage()) {
                if (this.isEmptyBannerDefault()) {
                    return []
                }
                this.basic.data.banner_image.value = this.basic.data.banner_image.default
            }
        }
        , isMultipleBanner () {
            return (this.bannerCount > 1) 
        }
        , isEmptyBannerDefault () {
            let bannerData = this.basic.data;
            return (bannerData.banner_image.default.length == 0)
        }
        , isEmptyBannerImage () {
            let bannerData = this.basic.data;
            if (bannerData.banner_image.value.length == 0) return true
            let list = []
            for (let key in bannerData.banner_image.value) {
                if (bannerData.banner_image.value[key].length > 0) {
                    list.push(bannerData.banner_image.value[key])
                }
            }
            return (list.length < 1)
        }
        , setBannerSwipe () {
            let option = {
                initialSlide : 0
                , loop: true
                , autoplay: {
                    delay: 3000
                }
                , slidesPerView: 1
                , pagination: {
                    el: '.swiper-pagination',
                }
                , autoHeight : true
                , a11y : false
            }

            this.deleteBannerSwipe()
            let bannerTpl = $m('#tpl-banner .banner-slide-tpl').html()
                bannerTpl = `<div class="visualTop swiper-container banner-slide" :style="${this.notUseBannerVisualTopStyle}">${bannerTpl}</div>`
            $m('#tpl-banner #header').parent().append(bannerTpl);
            bannerSwiper[bannerSwiperIndex] = new Swiper('#tpl-banner .banner-slide', option);
            bannerSwiperIndex++;
            if (this.getAdminEditMode()) {
                this.areaSettingDisplayNone()
            }
        }
        , deleteBannerSwipe () {
            $m('#tpl-banner .banner-slide').remove();
            if (bannerSwiperIndex > 0) {
                let bannerSwiperIndexPre = parseInt(bannerSwiperIndex) - 1
                if (bannerSwiper[bannerSwiperIndexPre]) { delete bannerSwiper[bannerSwiperIndexPre] }
            }
        }
        , bannerSwipe () {
            if (this.isMultipleBanner()) {
                this.setBannerSwipe()
                return;
            } 
            this.deleteBannerSwipe()
        }
        , areaSettingDisplayNone() {
            let btn = document.querySelectorAll('.visualTop .btn-area-setting')
            let border = document.querySelectorAll('.visualTop .section-border')
            for (let i=0; i<btn.length; i++) {
                btn[i].style.display = 'none'
            }
            for (let j=0; j<border.length; j++) {
                border[j].style.display = 'none'
            }
        }
        , useDesignBanner () {
            if (this.isSetBasicData('banner_image') && this.isSetBasicData('banner_max_cnt') === false) return false
            let bannerData = this.basic.data;
            if (bannerData.banner_image.value.length == 0) return false 
            if (bannerData.banner_max_cnt.value.length == 0) return false 
            return true
        }
        , checkOriginBannerList (bannerImage) {
            let chk = true
            if (this.isSetBasicData('banner_image') === false) return false
            if (this.originBannerList.length == 0) return false
            for (let i in bannerImage) {
                for (let j in this.originBannerList) {
                    if (this.originBannerList[j].includes(bannerImage[i]) === false) {
                        chk = false
                        break
                    }
                }
                if (chk === false) break
            }
            return chk
        }
        , setHeaderLogoImg() {
            let img = '';
            if (this.isScroll()) {
                if (this.isSetBasicData('prf_sub_logo') === true && this.isSetBasicData('prf_sub_logo_use') === true) {
                    if (this.basic.data.prf_sub_logo_use.value === 'Y') {
                    img = (this.basic.data.prf_sub_logo.value.length > 0) ? this.basic.data.prf_sub_logo.value : '';
                    }
                }
                if (img === '' && this.isSetBasicData('prf_logo')) {
                    img = (this.basic.data.prf_logo.value.length > 0) ? this.basic.data.prf_logo.value : '';
                }
            } else {
                if (this.isSetBasicData('prf_logo')) {
                    img = (this.basic.data.prf_logo.value.length > 0) ? this.basic.data.prf_logo.value : '';
                }
                if (img === '' && this.isSetBasicData('prf_sub_logo') === true && this.isSetBasicData('prf_sub_logo_use') === true) {
                    if (this.basic.data.prf_sub_logo_use.value === 'Y') {
                        img = (this.basic.data.prf_sub_logo.value.length > 0) ? this.basic.data.prf_sub_logo.value : '';
                    }
                }
            }
            this.headerLogoImg = img;
        }
        , setProfileIconColor() {
            let color = '';
            let defaultColor = '000000';
            if (this.isScroll()) {
                color = defaultColor;
            } else {
                color = (this.isSetBasicData('prf_icon_color')) ? this.basic.data.prf_icon_color.value : 'ffffff';
            }
            this.profileIconColor = color;
        }
        , setHeaderTitleColor() {
            let color = '';
            let defaultColor = '000000';
            if (this.isScroll()) {
                color = defaultColor;
            } else {
                color = (this.isSetBasicData('prf_text_color')) ? this.basic.data.prf_text_color.value : 'ffffff';
            }
            this.headerTitleColor = color;
        }
        , setHeaderScrollClass() {
            if (this.isScroll()) {
                this.headerScrollClass = 'scroll';
            } else {
                this.headerScrollClass = '';
            }
        }
        , setHeaderBottomColor() {
            if (this.isScroll()) {
                this.headerBottomColor = 'e6e6e6';
            } else {
                this.headerBottomColor = 'fff';
            }
        }
        , setBannerScrollHeader() {
            this.setHeaderLogoImg();
            this.setProfileIconColor();
            this.setHeaderTitleColor();
            this.setHeaderScrollClass();
            this.setHeaderBottomColor();
            let headerTop = this.isScroll() ? 0 : '80px';
            if (document.querySelector('#tpl-banner .topBanner + .base #header') != null) {
                document.querySelector('#tpl-banner .topBanner + .base #header').style['top'] = headerTop;
            }
        }
        , setBasicScrollHeader() {
            if(this.isScroll()){
                $m('.topBanner').slideUp(100);
                $m('.topBanner + #header').css('top','0');
            } else {
                $m('.topBanner').slideDown(100);
                $m('.topBanner + #header').css('top','80px');
            }
        }
        , isScroll() {
            let scrollTop = $m(window).scrollTop();
            if (scrollTop  > 0 ) {
                return true;
            }
            return false;
        }
		, goSearch () {
			//form 데이터 전달
			var keyword = $m('input[name="search_keyword"]').val();
			var blank = /^\s+|\s+$/g;
            if (keyword == '' || keyword == null || keyword.replace(blank,'') == "") {
                alert("검색어를 입력해주세요.");
                return false;
            }
			if (keyword.length > 250) {
				alert("최대 250자까지 입력 가능합니다.");
				return false;
			}
			return this.getAdminEditMode() ? '' : $m('#main_search_form').submit();
        }
    }
    , updated () {
        this.publisher()
        if (templateType === 'banner' && this.checkOriginBannerList(this.basic.data.banner_image.value) === false) {
            this.originBannerList = this.basic.data.banner_image.value
            
        }
    }
})
